import { Component } from 'react';
import moneyHelper from '../Helpers/moneyHelper';
import PricingDetailService from '../Services/PricingDetailService';

class GetActualAssignmentFeeValue extends Component {
    state = {
        text: ""
    }

    componentDidMount() {
        PricingDetailService.GetActualAssignmentFeeValue(this.props.OpportunityId)
            .then(result => {
                let value = moneyHelper.toMoneyFormat(result.value, this.props.OpportunityCurrency)
                this.setState({ text: value })
            })
            .catch(error => this.setState({ text: "Not found" }));
    }

    render() {
        return (this.state.text);
    }
}

export default GetActualAssignmentFeeValue;